import React from "react";
import { DatePicker } from "antd";
import dayjs from "dayjs";

import { DBTilte } from "./ExtensiveFilterContent";
import {
  CATEGORY_FILTER_OPTIONS,
  STATUS_FILTER_OPTIONS,
  CategoryFilterOption,
} from "./ExtensiveFilterContent";
import ExtensiveFilter from "./ExtensiveFilter";
import Drop from "../../assets/Polygon 2.svg";

const { RangePicker } = DatePicker;

interface FilterContentProps {
  accessorKey: string;
  searchField?: string;
  searchQueryLocal: any;
  isToggleCategory: boolean;
  isToggleStatus: boolean;
  handleFilterInputChange: (
    event:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLTextAreaElement>,
    field: string,
    operator: string,
    localField: string
  ) => void;
  handleDateRangeChange: (
    field: string,
    dates: any,
    localField: string
  ) => void;
  handleToggle: (field: string) => void;
  handleDropDownChanges: (item: string, field: string) => void;
  handleToClear: (field: string, field2?: string) => void;
  handleApplyFilter: () => void;
  handleFilterClose: () => void;
}

const FilterContent: React.FC<FilterContentProps> = ({
  accessorKey,
  searchField,
  searchQueryLocal,
  isToggleCategory,
  isToggleStatus,
  handleFilterInputChange,
  handleDateRangeChange,
  handleToggle,
  handleDropDownChanges,
  handleToClear,
  handleApplyFilter,
  handleFilterClose,
}) => {
  switch (accessorKey) {
    case "uniqueId":
      return (
        <div className="user-filter-container">
          <div className="filter-box-header">{searchField}</div>
          <input
            placeholder="Enter Unique ID"
            value={searchQueryLocal.NUniqueID.value}
            onChange={(e) =>
              handleFilterInputChange(
                e,
                DBTilte.NUniqueID,
                "contains",
                "NUniqueID"
              )
            }
            className="filter-box-input"
          />
          <div className="column-filter-button-div">
            <button
              className="column-filter-clear-btn"
              onClick={() => handleToClear(DBTilte.NUniqueID)}
            >
              Clear
            </button>
            <button
              onClick={handleApplyFilter}
              className="popup-create-btn column-filter-search-btn"
            >
              Search
            </button>
          </div>
        </div>
      );

    case "title":
      return (
        <div className="user-filter-container">
          <div className="filter-box-header">{searchField}</div>
          <textarea
            placeholder="Enter the title"
            value={searchQueryLocal.title.value}
            onChange={(e) =>
              handleFilterInputChange(e, DBTilte.title, "contains", "title")
            }
            className="filter-box-input"
            style={{ wordBreak: "break-word", resize: "none" }}
          />
          <div className="column-filter-button-div">
            <button
              className="column-filter-clear-btn"
              onClick={() => handleToClear("title")}
            >
              Clear
            </button>
            <button
              onClick={handleApplyFilter}
              className="popup-create-btn column-filter-search-btn"
            >
              Search
            </button>
          </div>
        </div>
      );

    case "createdBy":
      return (
        <div className="user-filter-container">
          <div className="filter-box-header">{searchField}</div>
          <input
            placeholder="Username"
            value={searchQueryLocal.createdBy.value}
            onChange={(e) =>
              handleFilterInputChange(
                e,
                DBTilte.createdBy,
                "contains",
                "createdBy"
              )
            }
            className="filter-box-input"
            style={{ marginBottom: "10px" }}
          />
          <div className="filter-box-header">Date</div>
          <div className="filter-date-picker">
            <RangePicker
              value={
                searchQueryLocal.createdOn.value &&
                searchQueryLocal.createdOn.value.length === 2
                  ? [
                      dayjs(searchQueryLocal.createdOn.value[0]),
                      dayjs(searchQueryLocal.createdOn.value[1]),
                    ]
                  : undefined
              }
              onChange={(dates: any, dateString: any) =>
                handleDateRangeChange(
                  DBTilte.createdOn,
                  dateString,
                  "createdOn"
                )
              }
              format="YYYY/MM/DD"
            />
          </div>
          <div className="column-filter-button-div">
            <button
              className="column-filter-clear-btn"
              onClick={() => handleToClear("createdBy", "createdOn")}
            >
              Clear
            </button>
            <button
              onClick={handleApplyFilter}
              className="popup-create-btn column-filter-search-btn"
            >
              Search
            </button>
          </div>
        </div>
      );

    case "updatedBy":
      return (
        <div className="user-filter-container">
          <div className="filter-box-header">{searchField}</div>
          <input
            placeholder="Username"
            value={searchQueryLocal.updatedBy.value}
            onChange={(e) =>
              handleFilterInputChange(
                e,
                DBTilte.updatedBy,
                "contains",
                "updatedBy"
              )
            }
            className="filter-box-input"
            style={{ marginBottom: "10px" }}
          />
          <div className="filter-box-header">Date</div>
          <div className="filter-date-picker">
            <RangePicker
              value={
                searchQueryLocal.updatedOn.value &&
                searchQueryLocal.updatedOn.value.length === 2
                  ? [
                      dayjs(searchQueryLocal.updatedOn.value[0]),
                      dayjs(searchQueryLocal.updatedOn.value[1]),
                    ]
                  : undefined
              }
              onChange={(dates: any, dateStrings: any) =>
                handleDateRangeChange(
                  DBTilte.updatedOn,
                  dateStrings,
                  "updatedOn"
                )
              }
              format="YYYY/MM/DD"
            />
          </div>
          <div className="column-filter-button-div">
            <button
              className="column-filter-clear-btn"
              onClick={() => handleToClear("updatedBy", "updatedOn")}
            >
              Clear
            </button>
            <button
              onClick={handleApplyFilter}
              className="popup-create-btn column-filter-search-btn"
            >
              Search
            </button>
          </div>
        </div>
      );

    case "category":
      return (
        <div className="user-filter-container">
          <div className="filter-box-header">Category</div>
          <div className="input-subContainer">
            <div
              className="dropdow-input-container"
              onClick={() => handleToggle("category")}
            >
              <span
                className="dropdown-spanElement"
                style={{ fontSize: "10px" }}
              >
                {searchQueryLocal.category.value !== ""
                  ? searchQueryLocal.category.value
                  : "Select Category"}
              </span>
              <img src={Drop} alt="" />
            </div>
          </div>
          {isToggleCategory && (
            <div className="category-dropDown-container">
              {CATEGORY_FILTER_OPTIONS.map((item: CategoryFilterOption) => (
                <div
                  key={item.value}
                  className="dropdownList-container"
                  onClick={() =>
                    handleDropDownChanges(`${item.value}`, "category")
                  }
                >
                  {item.label}
                </div>
              ))}
            </div>
          )}
          <div className="column-filter-button-div">
            <button
              className="column-filter-clear-btn"
              onClick={() => handleToClear("category")}
            >
              Clear
            </button>
            <button
              onClick={handleApplyFilter}
              className="popup-create-btn column-filter-search-btn"
            >
              Search
            </button>
          </div>
        </div>
      );

    case "status":
      return (
        <div className="user-filter-container">
          <div className="filter-box-header">Status</div>
          <div className="input-subContainer">
            <div
              className="dropdow-input-container"
              onClick={() => handleToggle("status")}
            >
              <span
                className="dropdown-spanElement"
                style={{ fontSize: "10px" }}
              >
                {searchQueryLocal.status.value !== ""
                  ? searchQueryLocal.status.value
                  : "Select Status"}
              </span>
              <img src={Drop} alt="" />
            </div>
          </div>
          {isToggleStatus && (
            <div className="category-dropDown-container">
              {STATUS_FILTER_OPTIONS.map((item: CategoryFilterOption) => (
                <div
                  key={item.value}
                  className={`filter-box-list-item ${item.className}`}
                  onClick={() =>
                    handleDropDownChanges(`${item.value}`, "status")
                  }
                >
                  {item.label}
                </div>
              ))}
            </div>
          )}
          <div className="column-filter-button-div">
            <button
              className="column-filter-clear-btn"
              onClick={() => handleToClear("status")}
            >
              Clear
            </button>
            <button
              onClick={handleApplyFilter}
              className="popup-create-btn column-filter-search-btn"
            >
              Search
            </button>
          </div>
        </div>
      );

    case "ExtensiveSearch":
      return <ExtensiveFilter onClose={handleFilterClose} />;

    default:
      return null;
  }
};

export default FilterContent;
